<template>
  <div class="content-page">
    <div class="flex-row-start">
      <div class="line"></div>
      <el-breadcrumb class="elArrowText" separator-class="el-icon-arrow-right">
        <!-- <el-breadcrumb-item>
          <a href="javascript:;">会员卡积分管理</a>
        </el-breadcrumb-item> -->
        <el-breadcrumb-item>积分记录</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="flex-row-start pt20">
      <div class="flex-row-start pr60">
        <div class="memberId">手机号：</div>
        <el-input v-model="phoneNum" onchange = "this.value=this.value.replace(/[^\d]/g,'')" placeholder="请输入手机号" />
      </div>
      <el-button type="primary" @click="search">查询</el-button>
    </div>
    <div class="table-area">
      <el-table
        :data="tableData"
        style="width: 100%"
        v-loading="loading"
        element-loading-background="rgba(0, 0, 0, 0.3)"
        element-loading-text="数据正在加载中"
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column
          align="center"
          prop="shopMemberId"
          label="会员卡ID"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="phoneNum"
          label="手机号"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="userScore"
          label="积分值"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="remark"
          label="备注"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="modifyTime"
          label="时间"
        ></el-table-column>
      </el-table>
      <!-- 分页 -->
      <div
        v-if="tableData.length > 0"
        class="block"
        style="float:right;margin-top:10px;"
      >
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pageNo"
          :page-size="queryInfo.row"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getCardScoreList } from "@/api/index";
export default {
  data() {
    return {
      tableData: [],
      queryInfo: {
        pageNo: 1,
        row: 10,
      },
      total: 0,
      loading: false,
      phoneNum: "",
      status: "",
    };
  },
  created() {
    this.getCardScoreList(this.phoneNum);
  },
  methods: {
    getCardScoreList(phoneNum) {
      this.loading = true;
      getCardScoreList({
        pageNumber: this.queryInfo.pageNo,
        row: this.queryInfo.row,
        phoneNum: phoneNum,
      }).then((res) => {
        this.loading = false;
        if (res.code == 1) {
          this.tableData = res.data.list;
          this.total = res.data.totalCount;
        } else if (res.code == -1) {
          this.tableData = [];
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleCurrentChange(val) {
      this.queryInfo.pageNo = val;
      if (this.status == 1) {
        this.getCardScoreList(this.phoneNum);
      } else {
        this.getCardScoreList();
      }
    },
    search() {
      this.status = 1;
      this.getCardScoreList(this.phoneNum);
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-table th {
  background-color: #f7f8fa;
}
.pt20 {
  padding-top: 20px;
  box-sizing: border-box;
}
.pr60 {
  padding-right: 60px;
  box-sizing: border-box;
}
.content-page {
  padding: 40px;
  box-sizing: border-box;
  .flex-row-start {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    .line {
      width: 3px;
      height: 20px;
      background-color: #3388ff;
    }
    .elArrowText {
      padding-left: 10px;
      box-sizing: border-box;
      padding-top: 2px;
    }
    .memberId {
      width: 110px;
      line-height: 40px;
      font-size: 14px;
    }
  }
  .table-area {
    padding-top: 60px;
    box-sizing: border-box;
  }
}
</style>
